import { apiClient } from "../../api/client";
import {
  createAirshowSolidPreviewRequest,
  parseAirshowSolidPreviewResponse,
  type AirshowSolidPreviewResponse,
} from "./airshowSolidContract";

export async function requestAirshowSolidPreview(input: {
  projectId: string;
  entryId: string;
  archiveMemberPath: string;
  sourceSha256: string;
  reviewBundleKey: string;
  signal?: AbortSignal;
}): Promise<AirshowSolidPreviewResponse> {
  if (!input.projectId.trim()) throw new Error("Airshow solid preview requires a project identity");
  const request = createAirshowSolidPreviewRequest(input);
  const response = await apiClient<unknown>(
    `/thread/v1/projects/${encodeURIComponent(input.projectId)}/aero/vsp/airshow/solid-previews`,
    { method: "POST", signal: input.signal, body: request },
  );
  return parseAirshowSolidPreviewResponse(response, { projectId: input.projectId, request });
}
